import React, { Fragment } from "react";
import Header from "../components/Header";
import Leftnav from "../components/Leftnav";
import Appfooter from "../components/Appfooter";
import { useTranslation } from "react-i18next";

const Contact = () => {
  const { t } = useTranslation("legal");

  return (
    <Fragment>
      <Header />
      <Leftnav />
      <div className="main-content right-chat-active">
        <div className="middle-sidebar-bottom">
          <div className="middle-sidebar-left">
            <div className="card w-100 border-0 bg-white shadow-xs p-4 mb-4 rounded-xxl">
              <h2 className="fw-700 mb-3">{t("contact.title")}</h2>
              <p className="text-grey-700">{t("contact.lead")}</p>

              <h4 className="fw-700 mt-4">{t("contact.s1t")}</h4>
              <p>{t("contact.s1d", { email: t("common.email") })}</p>

              <h4 className="fw-700 mt-4">{t("contact.s2t")}</h4>
              <p>{t("contact.s2d")}</p>

              <h4 className="fw-700 mt-4">{t("contact.s3t")}</h4>
              <p>{t("contact.s3d")}</p>
            </div>
          </div>
        </div>
      </div>
      <Appfooter />
    </Fragment>
  );
};

export default Contact;
